import ForgotPassword from './components/ForgotPassword';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import get from 'lodash/get';

import { requestResetLinkForEmail } from '../../shared/redux/passwordReset/actions';

function mapStateToProps(state){
  return {
    environment:state.version.environment,
    frontEndVersion:state.version.frontend,
    backEndVersion:state.version.backend,    
    isLoggedIn:get(state,['auth','token']) !== null,
    isLoaded:true,
    hasAdminPermission:true
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    requestResetLinkForEmail
  },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/index.js